export default "__VITE_ASSET__Yo8jccTX__"